/* eslint-disable max-len */
var Themes;

(function (Themes) {
  Themes["HERKKU"] = "theme-herkku";
  Themes["SMARKET"] = "theme-smarket";
  Themes["NEUTRAL"] = "theme-neutral";
  Themes["ALEPA"] = "theme-alepa";
  Themes["PRISMA"] = "theme-prisma";
  Themes["ABC"] = "theme-abc";
  Themes["SOKOS_HERKKU"] = "theme-sokos-herkku";
  Themes["SOKOSFI"] = "theme-sokosfi";
  Themes["SOKOS_HOTELS"] = "theme-sokos-hotels";
  Themes["MESTARIN_HERKKU"] = "theme-mestarin-herkku";
  Themes["SALE"] = "theme-sale";
  Themes["EPRISMA"] = "theme-eprisma";
})(Themes || (Themes = {}));

export { Themes };
//# sourceMappingURL=theme.types.js.map
